var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as availabilityAction from '../actions/availability.action';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { AvailabiltyService } from '../../availabilty.service';
var AvailabilityEffect = /** @class */ (function () {
    function AvailabilityEffect(actions, availabilityService, store) {
        var _this = this;
        this.actions = actions;
        this.availabilityService = availabilityService;
        this.store = store;
        this.getAvailableDays = this.actions.ofType(availabilityAction.GET_AVAILABILITY)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.availabilityService.getAvailableDays(body)
                .map(function (res) { return new availabilityAction.GetAvailabilitySuccess(res); })
                .catch(function (error) { return of(new availabilityAction.GetAvailabilityError(error)); });
        }));
        this.getAvailableFreelancers = this.actions.ofType(availabilityAction.GET_AVAILABLE_FREELANCERS)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.availabilityService.getAvailableFreelancers(body)
                .map(function (res) { return new availabilityAction.GetAvailableFreelancersSuccess(res); })
                .catch(function (error) { return of(new availabilityAction.GetAvailableFreelancersError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AvailabilityEffect.prototype, "getAvailableDays", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AvailabilityEffect.prototype, "getAvailableFreelancers", void 0);
    return AvailabilityEffect;
}());
export { AvailabilityEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/effects/availability.effect.ts.pre-build-optimizer.js